import { createCalendarViewContainer } from 'factories/CalendarView'
import selectors from 'selectors'
import actions from 'actions/requisitions'
import Component from 'components/Requisitions/CalendarView'

export default createCalendarViewContainer({ actions, selectors: selectors.requisitions })(Component)
